import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestApi } from '../RestApi/restApi';

interface dataLoadingInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class DataLoadingService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private restAPI: RestApi,
  ) { }

  extractService() {
    return this.http.post<dataLoadingInfo>(this.restAPI.GETEXTRACTDATA_URL, { headers: this.headers });
  }

  convertService() {
    return this.http.get<dataLoadingInfo>(this.restAPI.CONVERTTOJSONDATA_URL, { headers: this.headers });
  }

  loadToS3Service() {
    return this.http.get<dataLoadingInfo>(this.restAPI.LOADTOS3DATA_URL, { headers: this.headers });
  }

  retrieveMasterDataLoadLogService() {

    console.log("this.restAPI.RETRIEVE_MASTER_DATA_LOAD_LOG");

    console.log(this.restAPI.RETRIEVE_MASTER_DATA_LOAD_LOG);

    return this.http.get<dataLoadingInfo>(this.restAPI.RETRIEVE_MASTER_DATA_LOAD_LOG, { headers: this.headers });

  }

  extractConvertLoadService(dnsName) {

    // console.log("this.restAPI.INSERT_EXTRACT_BUILD_UPLOAD");

    console.log(this.restAPI.INSERT_EXTRACT_BUILD_UPLOAD);

    return this.http.get<dataLoadingInfo>(this.restAPI.INSERT_EXTRACT_BUILD_UPLOAD+"/"+dnsName, { headers: this.headers });

  }
  reteriveIncrementalExtractionHistory() {

    // console.log("this.restAPI.INSERT_EXTRACT_BUILD_UPLOAD");

    console.log(this.restAPI.RETERIVEINCREMENTALEXTRACTIONHISTORY);

    return this.http.get<dataLoadingInfo>(this.restAPI.RETERIVEINCREMENTALEXTRACTIONHISTORY, { headers: this.headers });

  }

  retrieveMasterDataLoadService() {

    console.log(this.restAPI.RETERIVEFULLDATALOADLOG);

    return this.http.get<dataLoadingInfo>(this.restAPI.RETERIVEFULLDATALOADLOG, { headers: this.headers });

  }


}
